import React from "react";
import { CheckCircleOutlined, HomeOutlined, LoadingOutlined, StopOutlined, WarningOutlined } from "@ant-design/icons";
import { Breadcrumb, Button, Checkbox, DatePicker, Form, Input, Modal, Select, Space, Tooltip } from "antd";
import "./vehicle_master.css";
import { FaPlusCircle } from "@react-icons/all-files/fa/FaPlusCircle";
import { useVehicleMasterLogic } from "../../components/hoc_vehicle_master";
import ModalCustomerMaster from "./modal_customer_master";

const VehicleMaster: React.FC = () => {

    const {
        form,
        isModalOpen,
        showModal,
        handleOk,
        handleCancel,
        brands,
        isBrandsLoading,
        models,
        isModelsLoading,
        provinces,
        isProvincesLoading,
        regencies,
        isRegenciesLoading,
        districts,
        isDistrictsLoading,
        villages,
        isVillagesLoading,
        regenciesBilling,
        isRegenciesLoadingBilling,
        districtsBilling,
        isDistrictsLoadingBilling,
        villagesBilling,
        isVillagesLoadingBilling,
        handleProvinceChange,
        handleRegencyChange,
        handleDistrictChange,
        handleVillageChange,
        handleProvinceChangeBilling,
        handleRegencyChangeBilling,
        handleDistrictChangeBilling,
        handleVillageChangeBilling,
        selectedProvince,
        selectedRegency,
        selectedDistrict,
        selectedProvinceBilling,
        selectedRegencyBilling,
        selectedDistrictBilling,
        regenciesStnk,
        isRegenciesLoadingStnk,
        districtsStnk,
        isDistrictsLoadingStnk,
        villagesStnk,
        isVillagesLoadingStnk,
        handleProvinceChangeStnk,
        handleRegencyChangeStnk,
        handleDistrictChangeStnk,
        handleVillageChangeStnk,
        selectedProvinceStnk,
        selectedRegencyStnk,
        selectedDistrictStnk,
        handleCustomerSelect,
        autosaveStatus,
        handleFormChange,
        handleDeactivateToggle,
        showStnk,
        handleShowStnkToggle,
        showCurrentUser,
        handleShowCurrentUserToggle,
        showBilling,
        handleShowBillingToggle,
    } = useVehicleMasterLogic();

    const transformStyle = {
        transform: "scale(0.80)",
        transformOrigin: "top left",
        width: "125%",
    };

    const status = Form.useWatch('status', form);


    return (

        <div id="iiok" style={transformStyle}>
            <div className="gjs-grid-row" id="ia7w">
                <div className="gjs-grid-column" id="i3r6">
                    <Breadcrumb
                        items={[
                            {
                                title: <HomeOutlined />,
                            },
                            {
                                href: "#/dashboard/data_vehicle_master",
                                title: (
                                    <>
                                        <span>Data Vehicle Master</span>
                                    </>
                                ),
                            },
                            {
                                title: "Vehicle Master",
                            },
                        ]}
                    />
                </div>
            </div>
            <div className="gjs-grid-row" id="ijq5l">
                <div className="gjs-grid-column" id="iqz03">
                    <Button className="gr-button">
                        <FaPlusCircle style={{ width: '1em', height: '1em', marginRight: '8px' }} />
                        New
                    </Button>
                    <Button className="gr-button" onClick={handleDeactivateToggle}>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style={{ width: '1em', height: '1em', marginRight: '8px' }}>
                            <path
                                fillRule="evenodd"
                                d="M9 1.5H5.625c-1.036 0-1.875.84-1.875 1.875v17.25c0 1.035.84 1.875 1.875 1.875h12.75c1.035 0 1.875-.84 1.875-1.875V12.75A3.75 3.75 0 0 0 16.5 9h-1.875a1.875 1.875 0 0 1-1.875-1.875V5.25A3.75 3.75 0 0 0 9 1.5Zm6.61 10.936a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 14.47a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z"
                                clipRule="evenodd"
                            />
                            <path d="M12.971 1.816A5.23 5.23 0 0 1 14.25 5.25v1.875c0 .207.168.375.375.375H16.5a5.23 5.23 0 0 1 3.434 1.279 9.768 9.768 0 0 0-6.963-6.963Z" />
                        </svg>
                        {status === 'Active' ? 'Deactive' : 'Active'}
                    </Button>
                    <Space style={{ marginLeft: '10px' }}>
                        {autosaveStatus === 'processing' && (
                            <Tooltip title="Autosave sedang berjalan...">
                                <LoadingOutlined style={{ color: '#1890ff' }} />
                            </Tooltip>
                        )}
                        {autosaveStatus === 'error' && (
                            <Tooltip title="Autosave bermasalah. Periksa konsol untuk detail.">
                                <WarningOutlined style={{ color: '#ff4d4f' }} />
                            </Tooltip>
                        )}
                        {autosaveStatus === 'stopped' && (
                            <Tooltip title="Autosave Stopped">
                                <StopOutlined style={{ color: '#bfbfbf' }} />
                            </Tooltip>
                        )}
                        {autosaveStatus === 'idle' && (
                            <Tooltip title="Autosave berhasil.">
                                <CheckCircleOutlined style={{ color: '#52c41a' }} />
                            </Tooltip>
                        )}
                    </Space>
                </div>
            </div>
            <div className="gjs-grid-row" id="i00fn">
                <div className="gjs-grid-column" id="ima4">
                    <Form
                        form={form}
                        layout="horizontal"
                        style={{ maxWidth: 450 }}
                        labelCol={{ style: { width: '170px', textAlign: "left" } }}
                        wrapperCol={{ style: { width: '290px' } }}
                        className="vehicle_master_form"
                        onValuesChange={handleFormChange}
                    >
                        <Form.Item
                            label="Status"
                            name="status"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input placeholder="" disabled />
                        </Form.Item>
                        <Form.Item
                            label="Vehicle Chassis No"
                            name="vehicle_chassis_no"
                            rules={[{ required: true, message: 'required!' }]}
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input placeholder="" />
                        </Form.Item>
                        <Form.Item
                            label="Vehicle Engine No"
                            name="vehicle_engine_no"
                            style={{
                                marginBottom: "5px",
                            }}

                        >
                            <Input placeholder="" />
                        </Form.Item>
                        <Form.Item
                            label="Brand"
                            name="brand"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Select
                                showSearch
                                placeholder=""
                                optionFilterProp="label"
                                style={{ width: "100%" }}
                                getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
                                loading={isBrandsLoading}
                                options={[
                                    { label: "— Empty —-", value: "" },
                                    ...(brands?.map(brand => ({
                                        label: brand.description,
                                        value: brand.code,
                                    })) || []),
                                ]}
                            />
                        </Form.Item>
                        <Form.Item
                            label="Model"
                            name="model"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Select
                                showSearch
                                placeholder=""
                                optionFilterProp="label"
                                style={{ width: "100%" }}
                                getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
                                loading={isModelsLoading}
                                options={[
                                    { label: "— Empty —-", value: "" },
                                    ...(models?.map(model => ({
                                        label: model.description,
                                        value: model.code,
                                    })) || []),
                                ]}
                            />
                        </Form.Item>

                        <Form.Item
                            label="Production"
                            name="production"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Select
                                showSearch
                                placeholder=""
                                optionFilterProp="label"
                                style={{ width: "100%" }}
                                getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
                                options={[
                                    { label: "-- Empty --", value: "" },
                                    { label: "1997", value: "1997" },
                                    { label: "1998", value: "1998" },
                                    { label: "1999", value: "1999" },
                                    { label: "2000", value: "2000" },
                                    { label: "2001", value: "2001" },
                                    { label: "2002", value: "2002" },
                                    { label: "2003", value: "2003" },
                                    { label: "2004", value: "2004" },
                                    { label: "2005", value: "2005" },
                                    { label: "2006", value: "2006" },
                                    { label: "2007", value: "2007" },
                                    { label: "2008", value: "2008" },
                                    { label: "2009", value: "2009" },
                                    { label: "2010", value: "2010" },
                                    { label: "2011", value: "2011" },
                                    { label: "2012", value: "2012" },
                                    { label: "2013", value: "2013" },
                                    { label: "2014", value: "2014" },
                                    { label: "2015", value: "2015" },
                                    { label: "2016", value: "2016" },
                                    { label: "2017", value: "2017" },
                                    { label: "2018", value: "2018" },
                                    { label: "2019", value: "2019" },
                                    { label: "2020", value: "2020" },
                                    { label: "2021", value: "2021" },
                                    { label: "2022", value: "2022" },
                                    { label: "2023", value: "2023" },
                                    { label: "2024", value: "2024" },
                                    { label: "2025", value: "2025" },
                                    { label: "2026", value: "2026" },
                                    { label: "2027", value: "2027" },
                                    { label: "2028", value: "2028" },
                                    { label: "2029", value: "2029" },
                                    { label: "2030", value: "2030" }
                                ]}
                            />
                        </Form.Item>
                        <Form.Item
                            label="Last KM"
                            name="last_km"
                            style={{
                                marginBottom: "5px", width: "70%"
                            }}
                        >
                            <Input placeholder="" />
                        </Form.Item>
                        <Form.Item
                            label="Vehicle Status"
                            name="vehicle_status"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input placeholder="" />
                        </Form.Item>
                        <div className="grid-2" style={{ paddingTop: "50px" }}>
                            <Form.Item
                                label={<span style={{ fontWeight: "600" }}>STNK</span>}
                                style={{
                                    marginBottom: "0px",
                                }}>
                                <div
                                    style={{
                                        gap: "0px",
                                        marginTop: "0px",
                                    }}>
                                    <Checkbox checked={showStnk} onChange={handleShowStnkToggle} style={{ fontWeight: 600 }}>
                                        Show
                                    </Checkbox>
                                </div>
                            </Form.Item>
                            {showStnk && (
                                <>
                                    <Form.Item
                                        label="No Polisi"
                                        name="no_polisi"
                                        style={{
                                            marginBottom: "5px",
                                        }}
                                    >
                                        <Input placeholder="" />
                                    </Form.Item>
                                    <Form.Item
                                        label="No STNK"
                                        name="no_stnk"
                                        style={{
                                            marginBottom: "5px",
                                        }}
                                    >
                                        <Input placeholder="" />
                                    </Form.Item>
                                    <Form.Item
                                        label="Date"
                                        name="date"
                                        style={{
                                            marginBottom: "5px",
                                        }}
                                    >
                                        <DatePicker
                                            format="DD/MM/YYYY"
                                            placeholder="Select date"
                                            style={{ width: "40%", fontSize: "14px" }}
                                            popupStyle={{ fontSize: "12px" }}
                                        />
                                    </Form.Item>
                                    <Form.Item
                                        label="Name"
                                        name="name"
                                        style={{
                                            marginBottom: "5px",
                                        }}
                                    >
                                        <Input placeholder="" />
                                    </Form.Item>
                                    <Form.Item
                                        label="Address"
                                        name="address"
                                        style={{
                                            marginBottom: "5px",
                                        }}
                                    >
                                        <Input.TextArea rows={3} />
                                    </Form.Item>
                                    <Form.Item
                                        label="Provinsi"
                                        name="provinsi_stnk"
                                        style={{
                                            marginBottom: "5px",
                                        }}
                                    >
                                        <Select
                                            showSearch
                                            placeholder=""
                                            optionFilterProp="label"
                                            style={{ width: "100%" }}
                                            getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
                                            loading={isProvincesLoading}
                                            onChange={handleProvinceChangeStnk}
                                            options={[
                                                { label: "— Empty —-", value: "" },
                                                ...(provinces?.map(prov => ({
                                                    label: prov.nama_provinsi,
                                                    value: prov.kode_provinsi,
                                                })) || []),
                                            ]}
                                        />
                                    </Form.Item>
                                    <Form.Item
                                        label="Kabupaten"
                                        name="kabupaten_stnk"
                                        style={{
                                            marginBottom: "5px",
                                        }}
                                    >
                                        <Select
                                            showSearch
                                            placeholder=""
                                            optionFilterProp="label"
                                            style={{ width: "100%" }}
                                            getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
                                            disabled={!selectedProvinceStnk}
                                            loading={isRegenciesLoadingStnk}
                                            onChange={handleRegencyChangeStnk}
                                            options={[
                                                { label: "— Empty —-", value: "" },
                                                ...(regenciesStnk?.map(reg => ({
                                                    label: reg.deskripsi_kode_dati,
                                                    value: reg.kode_dati,
                                                })) || []),
                                            ]}
                                        />
                                    </Form.Item>
                                    <Form.Item
                                        label="Kecamatan"
                                        name="kecamatan_stnk"
                                        style={{
                                            marginBottom: "5px",
                                        }}
                                    >
                                        <Select
                                            showSearch
                                            placeholder=""
                                            optionFilterProp="label"
                                            style={{ width: "100%" }}
                                            getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
                                            disabled={!selectedRegencyStnk}
                                            loading={isDistrictsLoadingStnk}
                                            onChange={handleDistrictChangeStnk}
                                            options={[
                                                { label: "— Empty —-", value: "" },
                                                ...(districtsStnk?.map(dist => ({
                                                    label: dist.deskripsi_kode_kecamatan,
                                                    value: dist.kode_kecamatan,
                                                })) || []),
                                            ]}
                                        />
                                    </Form.Item>
                                    <Form.Item
                                        label="Kelurahan"
                                        name="kelurahan_stnk"
                                        style={{
                                            marginBottom: "5px",
                                        }}
                                    >
                                        <Select
                                            showSearch
                                            placeholder=""
                                            optionFilterProp="label"
                                            style={{ width: "100%" }}
                                            getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
                                            disabled={!selectedDistrictStnk}
                                            loading={isVillagesLoadingStnk}
                                            onChange={handleVillageChangeStnk}
                                            options={[
                                                { label: "— Empty —-", value: "" },
                                                ...(villagesStnk?.map(vill => ({
                                                    label: vill.deskripsi_kode_kelurahan,
                                                    value: vill.kode_kelurahan,
                                                })) || []),
                                            ]}
                                        />
                                    </Form.Item>
                                    <Form.Item
                                        label="Kode Pos"
                                        name="kode_pos_stnk"
                                        style={{
                                            marginBottom: "5px",
                                        }}
                                    >
                                        <Input placeholder="" />
                                    </Form.Item>
                                </>
                            )}
                        </div>
                        <div className="grid-2" style={{ paddingTop: "50px" }}>
                            <Form.Item
                                label={<span style={{ fontWeight: "600" }}>Current User</span>}
                                style={{
                                    marginBottom: "0px",
                                }}>
                                <div
                                    style={{
                                        gap: "0px",
                                        marginTop: "0px",
                                    }}>
                                    <Checkbox checked={showCurrentUser} onChange={handleShowCurrentUserToggle} style={{ fontWeight: 600 }}>
                                        Show
                                    </Checkbox>
                                </div>
                            </Form.Item>
                            {showCurrentUser && (
                                <>
                                    <div className="grid2">
                                        <Form.Item
                                            label="Customer Name"
                                            style={{ marginBottom: "5px", width: "450px" }} >
                                            <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                                                <Form.Item
                                                    name="customer_name_current_user"
                                                    noStyle
                                                    style={{ width: "100%" }}>
                                                    <Input
                                                        style={{ width: "100%" }}
                                                    />
                                                </Form.Item>
                                                <Button
                                                    type="primary"
                                                    id="modal_customer_master_current_user"
                                                    onClick={() => showModal('currentUser')}
                                                    icon={
                                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style={{ width: "40px", height: "20px" }}>
                                                            <path d="M11.625 16.5a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75Z" />
                                                            <path fillRule="evenodd" d="M5.625 1.5H9a3.75 3.75 0 0 1 3.75 3.75v1.875c0 1.036.84 1.875 1.875 1.875H16.5a3.75 3.75 0 0 1 3.75 3.75v7.875c0 1.035-.84 1.875-1.875 1.875H5.625a1.875 1.875 0 0 1-1.875-1.875V3.375c0-1.036.84-1.875 1.875-1.875Zm6 16.5c.66 0 1.277-.19 1.797-.518l1.048 1.048a.75.75 0 0 0 1.06-1.06l-1.047-1.048A3.375 3.375 0 1 0 11.625 18Z" clipRule="evenodd" />
                                                            <path d="M14.25 5.25a5.23 5.23 0 0 0-1.279-3.434 9.768 9.768 0 0 1 6.963 6.963A5.23 5.23 0 0 0 16.5 7.5h-1.875a.375.375 0 0 1-.375-.375V5.25Z" />
                                                        </svg>}
                                                />
                                            </div>
                                        </Form.Item>
                                    </div>
                                    <Form.Item
                                        label="No ID"
                                        name="no_id_current_user"
                                        style={{
                                            marginBottom: "5px",
                                        }}
                                    >
                                        <Input placeholder="" />
                                    </Form.Item>
                                    <Form.Item
                                        label="Address"
                                        name="address_current_user"
                                        style={{
                                            marginBottom: "5px",
                                        }}
                                    >
                                        <Input.TextArea rows={4} placeholder="" />
                                    </Form.Item>
                                    <Form.Item
                                        label="Provinsi"
                                        name="provinsi_current_user"
                                        style={{
                                            marginBottom: "5px",
                                        }}
                                    >
                                        <Select
                                            showSearch
                                            placeholder=""
                                            optionFilterProp="label"
                                            style={{ width: "100%" }}
                                            getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
                                            loading={isProvincesLoading}
                                            onChange={handleProvinceChange}
                                            options={[
                                                { label: "— Empty —-", value: "" },
                                                ...(provinces?.map(prov => ({
                                                    label: prov.nama_provinsi,
                                                    value: prov.kode_provinsi,
                                                })) || []),
                                            ]}
                                        />
                                    </Form.Item>
                                    <Form.Item
                                        label="Kabupaten"
                                        name="kabupaten_current_user"
                                        style={{
                                            marginBottom: "5px",
                                        }}
                                    >
                                        <Select
                                            showSearch
                                            placeholder=""
                                            optionFilterProp="label"
                                            style={{ width: "100%" }}
                                            getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
                                            disabled={!selectedProvince}
                                            loading={isRegenciesLoading}
                                            onChange={handleRegencyChange}
                                            options={[
                                                { label: "— Empty —-", value: "" },
                                                ...(regencies?.map(reg => ({
                                                    label: reg.deskripsi_kode_dati,
                                                    value: reg.kode_dati,
                                                })) || []),
                                            ]}
                                        />
                                    </Form.Item>
                                    <Form.Item
                                        label="Kecamatan"
                                        name="kecamatan_current_user"
                                        style={{
                                            marginBottom: "5px",
                                        }}
                                    >
                                        <Select
                                            showSearch
                                            placeholder=""
                                            optionFilterProp="label"
                                            style={{ width: "100%" }}
                                            getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
                                            disabled={!selectedRegency}
                                            loading={isDistrictsLoading}
                                            onChange={handleDistrictChange}
                                            options={[
                                                { label: "— Empty —-", value: "" },
                                                ...(districts?.map(dist => ({
                                                    label: dist.deskripsi_kode_kecamatan,
                                                    value: dist.kode_kecamatan,
                                                })) || []),
                                            ]}
                                        />
                                    </Form.Item>
                                    <Form.Item
                                        label="Kelurahan"
                                        name="kelurahan_current_user"
                                        style={{
                                            marginBottom: "5px",
                                        }}
                                    >
                                        <Select
                                            showSearch
                                            placeholder=""
                                            optionFilterProp="label"
                                            style={{ width: "100%" }}
                                            getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
                                            disabled={!selectedDistrict}
                                            loading={isVillagesLoading}
                                            onChange={handleVillageChange}
                                            options={[
                                                { label: "— Empty —-", value: "" },
                                                ...(villages?.map(vill => ({
                                                    label: vill.deskripsi_kode_kelurahan,
                                                    value: vill.kode_kelurahan,
                                                })) || []),
                                            ]}
                                        />
                                    </Form.Item>
                                    <Form.Item
                                        label="Kode Pos"
                                        name="kode_pos_current_user"
                                        style={{
                                            marginBottom: "5px",
                                        }}
                                    >
                                        <Input placeholder="" />
                                    </Form.Item>
                                    <Form.Item
                                        label="Phone Number"
                                        name="phone_number_current_user"
                                        style={{
                                            marginBottom: "5px",
                                        }}
                                    >
                                        <Input placeholder="" />
                                    </Form.Item>
                                </>
                            )}
                        </div>
                        <div className="grid-2" style={{ paddingTop: "50px" }}>
                            <Form.Item
                                label={<span style={{ fontWeight: "600" }}>Billing</span>}
                                style={{
                                    marginBottom: "0px",
                                }}>
                                <div
                                    style={{
                                        gap: "0px",
                                        marginTop: "0px",
                                    }}>
                                    <Checkbox checked={showBilling} onChange={handleShowBillingToggle} style={{ fontWeight: 600 }}>
                                        Show
                                    </Checkbox>
                                </div>
                            </Form.Item>
                            {showBilling && (
                                <>
                                    <div className="grid2">
                                        <Form.Item
                                            label="Customer Name"
                                            style={{ marginBottom: "5px", width: "450px" }} >
                                            <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                                                <Form.Item
                                                    name="customer_name_billing"
                                                    noStyle
                                                    style={{ width: "100%" }}>
                                                    <Input
                                                        style={{ width: "100%" }}
                                                    />
                                                </Form.Item>
                                                <Button
                                                    type="primary"
                                                    id="modal_customer_master_billing"
                                                    onClick={() => showModal('billing')}
                                                    icon={
                                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style={{ width: "40px", height: "20px" }}>
                                                            <path d="M11.625 16.5a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75Z" />
                                                            <path fillRule="evenodd" d="M5.625 1.5H9a3.75 3.75 0 0 1 3.75 3.75v1.875c0 1.036.84 1.875 1.875 1.875H16.5a3.75 3.75 0 0 1 3.75 3.75v7.875c0 1.035-.84 1.875-1.875 1.875H5.625a1.875 1.875 0 0 1-1.875-1.875V3.375c0-1.036.84-1.875 1.875-1.875Zm6 16.5c.66 0 1.277-.19 1.797-.518l1.048 1.048a.75.75 0 0 0 1.06-1.06l-1.047-1.048A3.375 3.375 0 1 0 11.625 18Z" clipRule="evenodd" />
                                                            <path d="M14.25 5.25a5.23 5.23 0 0 0-1.279-3.434 9.768 9.768 0 0 1 6.963 6.963A5.23 5.23 0 0 0 16.5 7.5h-1.875a.375.375 0 0 1-.375-.375V5.25Z" />
                                                        </svg>}
                                                />
                                            </div>
                                        </Form.Item>
                                    </div>
                                    <Form.Item
                                        label="No ID"
                                        name="no_id_billing"
                                        style={{
                                            marginBottom: "5px",
                                        }}
                                    >
                                        <Input placeholder="" />
                                    </Form.Item>
                                    <Form.Item
                                        label="Address"
                                        name="address_billing"
                                        style={{
                                            marginBottom: "5px",
                                        }}
                                    >
                                        <Input.TextArea rows={4} placeholder="" />
                                    </Form.Item>
                                    <Form.Item
                                        label="Provinsi"
                                        name="provinsi_billing"
                                        style={{
                                            marginBottom: "5px",
                                        }}
                                    >
                                        <Select
                                            showSearch
                                            placeholder=""
                                            optionFilterProp="label"
                                            style={{ width: "100%" }}
                                            getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
                                            loading={isProvincesLoading}
                                            onChange={handleProvinceChangeBilling}
                                            options={[
                                                { label: "— Empty —-", value: "" },
                                                ...(provinces?.map(prov => ({
                                                    label: prov.nama_provinsi,
                                                    value: prov.kode_provinsi,
                                                })) || []),
                                            ]}
                                        />
                                    </Form.Item>
                                    <Form.Item
                                        label="Kabupaten"
                                        name="kabupaten_billing"
                                        style={{
                                            marginBottom: "5px",
                                        }}
                                    >
                                        <Select
                                            showSearch
                                            placeholder=""
                                            optionFilterProp="label"
                                            style={{ width: "100%" }}
                                            getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
                                            disabled={!selectedProvinceBilling}
                                            loading={isRegenciesLoadingBilling}
                                            onChange={handleRegencyChangeBilling}
                                            options={[
                                                { label: "— Empty —-", value: "" },
                                                ...(regenciesBilling?.map(reg => ({
                                                    label: reg.deskripsi_kode_dati,
                                                    value: reg.kode_dati,
                                                })) || []),
                                            ]}
                                        />
                                    </Form.Item>
                                    <Form.Item
                                        label="Kecamatan"
                                        name="kecamatan_billing"
                                        style={{
                                            marginBottom: "5px",
                                        }}
                                    >
                                        <Select
                                            showSearch
                                            placeholder=""
                                            optionFilterProp="label"
                                            style={{ width: "100%" }}
                                            getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
                                            disabled={!selectedRegencyBilling}
                                            loading={isDistrictsLoadingBilling}
                                            onChange={handleDistrictChangeBilling}
                                            options={[
                                                { label: "— Empty —-", value: "" },
                                                ...(districtsBilling?.map(dist => ({
                                                    label: dist.deskripsi_kode_kecamatan,
                                                    value: dist.kode_kecamatan,
                                                })) || []),
                                            ]}
                                        />
                                    </Form.Item>
                                    <Form.Item
                                        label="Kelurahan"
                                        name="kelurahan_billing"
                                        style={{
                                            marginBottom: "5px",
                                        }}
                                    >
                                        <Select
                                            showSearch
                                            placeholder=""
                                            optionFilterProp="label"
                                            style={{ width: "100%" }}
                                            getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
                                            disabled={!selectedDistrictBilling}
                                            loading={isVillagesLoadingBilling}
                                            onChange={handleVillageChangeBilling}
                                            options={[
                                                { label: "— Empty —-", value: "" },
                                                ...(villagesBilling?.map(vill => ({
                                                    label: vill.deskripsi_kode_kelurahan,
                                                    value: vill.kode_kelurahan,
                                                })) || []),
                                            ]}
                                        />
                                    </Form.Item>
                                    <Form.Item
                                        label="Kode Pos"
                                        name="kode_pos_billing"
                                        style={{
                                            marginBottom: "5px",
                                        }}
                                    >
                                        <Input placeholder="" />
                                    </Form.Item>
                                    <Form.Item
                                        label="Phone Number"
                                        name="phone_number_billing"
                                        style={{
                                            marginBottom: "5px",
                                        }}
                                    >
                                        <Input placeholder="" />
                                    </Form.Item>
                                </>
                            )}
                        </div>
                    </Form>
                </div>
            </div>
            <Modal
                title="Customer Master"
                open={isModalOpen}
                onCancel={handleCancel}
                width={1000}
                centered
                footer={null}
            >
                <ModalCustomerMaster onCustomerSelect={handleCustomerSelect} />
            </Modal>
        </div>
    );
};

export default VehicleMaster;